<!-- 优惠码使用 -->
<template>
  <van-field
    v-model="sms"
    center
    clearable
    label=""
    class="coupon_input"
    :placeholder="$t('footerbtn.coupon.placeholder')"
  >
    <template #button>
      <van-button
        size="small"
        class="coupon_use_btn"
      >{{$t('footerbtn.coupon.btntext')}}</van-button>
    </template>
  </van-field>
</template>

<script>
export default {
  name: 'CouponInput',
  data() {
    return {

    };
  },

  components: {},

  methods: {

  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.coupon_input {
  width: 90%;
  margin: 0 auto;
  border-radius: 4px;
  padding: 5px 10px;
  padding-left: 20px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  .coupon_use_btn {
    padding: 0 15px;
    border-radius: 4px;
    letter-spacing: 1px;
    height: 40px;
    font-size: 14px;
    font-weight: bold;
    background-color: var(--bgColor);
    border-color: var(--bgColor);
    color: var(--fontColor);
  }
}
</style>